module.exports = __webpack_public_path__ + "static/media/haroun.70b127db.webp";